var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav bar variants"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 6.3999H6V8.3999H4V6.3999ZM4 11.3999H6V13.3999H4V11.3999ZM4 16.3999H6V18.3999H4V16.3999ZM20 8.3999V6.3999H8.023V8.3999H18.8H20ZM8 11.3999H20V13.3999H8V11.3999ZM8 16.3999H20V18.3999H8V16.3999Z",
    fill: "#E9F4FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientList);
export default __webpack_public_path__ + "static/media/patient-list.c2f872c8897a3c4770de7c4d97f47c52.svg";
export { ForwardRef as ReactComponent };